/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect, useRef } from "react";
import "./style.scss";

//assets
import { SvgCross } from "assets/icons/js/SvgCross";
import { SvgSearch } from "assets/icons/js/SvgSearch";

const GreyInputBox = (props) => {
	const [temp, setTemp] = useState(props.value);
	const inputRef = useRef();

	useEffect(() => {
		const timer = setTimeout(() => {
			props.onChange(temp);
		}, props.timeout);
		return () => {
			clearTimeout(timer);
		};
	}, [temp]);

	useEffect(() => {
		setTemp(props.value);
	}, [props.value]);

	useEffect(() => {
		if (props.autoFocus) inputRef.current.focus();
	}, []);
	return (
		<div
			className={`greyInputBoxWrapper ${props.className}`}
			style={{ ...(props?.theme?.borderBtn || {}) }}
		>
			{props.searchIcon && <SvgSearch width="20" />}
			<input
				id="greyInputBox"
				type="text"
				style={{
					background: props?.theme?.background,
					color: props?.theme?.primaryTextColor,
				}}
				value={temp}
				onChange={(e) => setTemp(e.target.value)}
				className={`greyInputBox`}
				placeholder={props.placeholder ? props.placeholder : "Search"}
				ref={inputRef}
			/>
			{temp && (
				<SvgCross
					className="greyBoxCloseIcon"
					onClick={() => setTemp("")}
					alt=""
				/>
			)}
		</div>
	);
};

GreyInputBox.defaultProps = {
	timeout: 0,
	autoFocus: false,
};
export default GreyInputBox;
